import { CircleIcon } from "components";
import { StarIndicators } from "modules/Appointments/components";
import CartIndicators from "modules/Appointments/components/SpecialIndicators/CartIndicators";
import "modules/Appointments/components/SpecialIndicators/SpecialIndicators.scss";
import { useGetSpecialIndicators } from "modules/Appointments/hooks";

export type IndicatorFilters = {
  icon: string;
  active: boolean;
  filter: string;
  text?: string;
  borderColor?: string;
};

export const SpecialIndicators = () => {
  const { indicatorFilters, handleIndicatorFilters } = useGetSpecialIndicators();

  return (
    <div className="SpecialIndicators">
      {indicatorFilters.map((item, index) => {
        return (
          <CircleIcon
            key={item.filter}
            icon={item.icon}
            disabled={!item.active}
            borderColor={item.borderColor}
            color={item.borderColor}
            onClick={() => handleIndicatorFilters(index)}
          />
        );
      })}
      <CartIndicators />
      <StarIndicators />
    </div>
  );
};
